import { colors, pxToRem } from '@themes';

var SelectPaperStyles = function SelectPaperStyles(theme) {
  return {
    transform: 'translateY(8px)',
    borderRadius: pxToRem(14)
  };
};

var SelectMenuStyles = function SelectMenuStyles(theme) {
  return {
    paddingTop: theme === null || theme === void 0 ? void 0 : theme.spacing(1),
    paddingBottom: theme === null || theme === void 0 ? void 0 : theme.spacing(1),
    li: {
      padding: theme === null || theme === void 0 ? void 0 : theme.spacing(0.75, 1.5),
      fontWeight: 400,
      fontSize: pxToRem(14),
      lineHeight: pxToRem(20),
      color: colors.comet,
      '&:hover': {
        backgroundColor: colors.gin
      },
      ':last-child': {
        marginBottom: theme === null || theme === void 0 ? void 0 : theme.spacing(0)
      },
      '&.Mui-selected': {
        backgroundColor: colors.gin
      },
      '&.Mui-selected:hover': {
        backgroundColor: colors.gin
      },
      '&.Mui-selected:focus': {
        backgroundColor: colors.gin
      }
    }
  };
};

export { SelectMenuStyles, SelectPaperStyles };